module.exports = __webpack_public_path__ + "img/paypal.a4f4a66d.png";